import { Component, OnInit } from '@angular/core';
import { GenService } from '../../shared/gen-ser.service';
@Component({
  selector: 'bs-month-view',
  templateUrl: './bs-month-view.component.html',
  styleUrls: ['./bs-month-view.component.css']
})
export class BSMonthViewComponent implements OnInit {

  selMonth = new Date();

  constructor() { }

  ngOnInit() {
  }

  prevMonthClick(evnt){
    this.selMonth.setMonth(this.selMonth.getMonth() - 1);
  }
  nextMonthClick(evnt){
    this.selMonth.setMonth(this.selMonth.getMonth() + 1);
  }
  todayClick(evnt){
    this.selMonth = new Date();
  }

  getSelMonthStr():string{
    return GenService.getDateFormatStr(this.selMonth,"MMM YYYY");
  }
}
